// extracted by mini-css-extract-plugin
export default {"input-stripe":"styles_input-stripe__wZ5il"};